import React from "react";
import styled from "styled-components";
import brandLight from "./logo.png";
import brandDark from "./logo-dark.png";

const MainBrand = styled.div`
  img {
    width: ${({ width }) => width};
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  /* Default / light theme */
  .v-light &, & {
    .logo-dark {
      display: block;
    }
    .logo-light {
      display: none;
    }
  }

  /* Dark theme */
  .v-dark & {
    .logo-dark {
      display: none;
    }
    .logo-light {
      display: block;
    }
  }
`;

const Brand = ({ width, alt }) => {
  return (
    <MainBrand width={width} className="main-brand">
      <img
        className="logo-dark"
        src={brandLight}
        alt={`${alt} - logo light`}
      />
      <img
        className="logo-light"
        src={brandDark}
        alt={`${alt} - logo dark`}
      />
    </MainBrand>
  );
};

MainBrand.defaultProps = {
  width: "80px",
};

Brand.defaultProps = {
  alt: "Pavex Ceramique",
};

export default React.memo(Brand);
     